var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "overflow-x": "auto", "min-width": "1200px" },
      attrs: { id: "app" }
    },
    [
      _c("pc-header", { staticClass: "header" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("pc-menu", { staticClass: "menu" }),
          _vm._v(" "),
          _c("router-view", { key: _vm.$route.fullPath, staticClass: "app" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f62530e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f62530e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pc/index.vue
// module id = null
// module chunks = 